import styled from 'styled-components';
import { TableHeaderMixin } from '../../mixins/components/TableHeaderMixin';
export var StyledTableHeader = /*#__PURE__*/styled.thead.withConfig({
  displayName: "StyledTableHeader",
  componentId: "c11n-8-111-1__sc-1x6l2ce-0"
})(["", ""], TableHeaderMixin);